import { GET_COLLECTION, GET_COLLECTIONS } from "@/graphql/queries/collections"
import { graphqlClient } from "@/lib/clients/graphql-request-client"

export const fetchCollection = async (slug: string) => {
  const { collection } = await graphqlClient.request(GET_COLLECTION, {
    slug,
  })

  return collection
}

export const fetchTopLevelCollections = async () => {
  const { collections } = await graphqlClient.request(GET_COLLECTIONS, {
    options: { topLevelOnly: true },
  })

  return collections
}
